module.exports = __webpack_public_path__ + "static/img/picture14.719681df.png";